import { $http } from '../request'

/** 分享 */
export interface IShareLinkType {
  sourceType: 'Listing' | 'Article' | 'Flashsale' | 'GroupBuying' | 'GroupBuyingTeam' | 'ActivityPage' | 'Store' |'NewArrival',
  sourceId?: string | number,
  channel?: string
  generateShortLink?: boolean
  internalLatestTrafficSourceModule?: string
  internalLatestTrafficSourceType?: string
  internalLatestTrafficSourcePage?: string
}
export const getShareLink = (params: IShareLinkType) => {
  return $http.get({
    url: `/share-link`,
    params: {
      ...params,
      generateShortLink: params.generateShortLink ?? true
    },
    loading: true
  })
}
